<template>
  <div class="logo-swiper">
    <h1>热门企业 <span @click="$router.push('/hotco')">更多企业<Icon type="right"  style="width: 1.5em"></Icon></span></h1>
    <div class="hot-wrapper">
      <swiper class="hot-swiper" :options="swiperOption">
        <swiper-slide class="group" v-for="(row, index) in list" :key="index">
          <router-link v-for="(co, index2) in row" :key="index2" :to="`/company/${co.name}`"><img :src="co.image"></router-link>
        </swiper-slide>
      </swiper>
      <div class="hot-pagination"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Icon from './Icon.vue'

export default {
  props: {
    title: String,
    more: String,
    row: {
      type: Number,
      default: 1
    },
    logo: Array
  },
  data() {
    return {
      list: [],
      swiperOption: {
        slidesPerView : 4,
        pagination: {
          el: '.hot-pagination',
          bulletClass : 'hot-bullet',
          bulletActiveClass: 'hot-bullet-active',
        },
      },
    }
  },
  methods: {
    openDetail() {
      this.$router.push('/detail/' + (this.job.sync_jobid || this.job.jobid || '120500417')).catch(err => {
          console.log('报错：',err)
      })
    },
    enterCo(job) {
      if(job.coid) {
        this.$router.push('/company/' + job.coname)
      }
    }
  },
  components: {
    swiper, swiperSlide, Icon
  },
  created() {
    const format = (list, row) => {
      function _format(list, row, result) {
        if(list.length > 0) {
          if(result[result.length-1] && result[result.length-1].length < row) {
            result[result.length-1].push(list[0])
            return _format(list.slice(1), row, result)
          } else {
            result.push([list[0]])
            return _format(list.slice(1), row, result)
          }
        } else {
          return result
        }
      }
      return _format(list, row, [])
    }
    // 将数组格式化为  二维数组， 行大小由row决定
    this.list = format(this.logo, 1)
  }
}
</script>

<style lang="scss">


.logo-swiper{
  .hot-wrapper{
    overflow: hidden;
    width: 100%;
  }
  .hot-swiper {
    margin: 16px auto 0; width: 688px; overflow: visible !important;
    img { display: block; width:160px; height:160px; background:rgba(255,255,255,1); box-shadow:0px 8px 32px 0px rgba(0,0,0,0.1); border-radius:8px;}
    a:nth-child(2) {display: block; margin-top: 16px}
  }
  .hot-pagination {
    margin: 40px auto 0; width:160px; height:8px; background:rgba(229,229,229,1); border-radius:4px; display: flex;
    .hot-bullet { flex: 1; }
    .hot-bullet-active { background:rgba(26,72,156,1); border-radius:4px; }
  }
  > h1 { margin-top: 64px; margin-bottom: 16px; font-size:34px; height: 34px; font-weight:bold; color:#333333;
      line-height: 1; display: flex; align-items: center;
    &::before {
      content: ''; display: inline-block; margin-right: 8px; width: 8px; height: 8px; background:#333333;
      box-shadow: 0 12px 0 0 #333333, 0 -12px 0 0 #333333; border-radius: 1px;
    }
    > span { flex: 1; font-size:24px; color:rgba(102,102,102,1); font-weight: 400; line-height:32px; text-align: right; }
  }
}

</style>